export default __webpack_public_path__ + "static/media/instagram-starwars.7bcec6e0.jpg";